import React from "react";
import { Statistic } from "antd";

const PhoneNumber = ({ value, ...prop }) => {
  return (
    <Statistic
      {...prop}
      value={value}
    />
  );
};

export default PhoneNumber;

